import { TreeConfig } from './types';

function config(treeThis?: any): Partial<TreeConfig> {
    const staticConfig: Partial<TreeConfig> = {
        showRowLines: true,
        columnAutoWidth: false,
        keyExpr: 'treeId',
        parentIdExpr: 'parentId',
        hasItemsExpr: 'hasItems',
        rootValue: '',
        loadPanel: {
            enabled: true
        },
        scrolling: {
            mode: 'virtual',
            useNative: false,
            scrollByThumb: true,
            scrollByContent: true,
            showScrollbar: 'always',
        },
        selection: {
            mode: 'single'
        },
        filterRow: {
            visible: true,
        },
        headerFilter: {
            visible: true,
        },
        groupPanel: {
            visible: true,
        },
        grouping: {
            autoExpandAll: true,
        },
        sorting: {
            mode: 'multiple',
        }
    };

    return Object.assign({}, staticConfig);
}

export default config;
